import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import TenantProvider from '@/core/tenant/tenantProvider';
import BrandingProvider from '@/core/branding/brandingProvider';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TenantProvider>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </TenantProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js?v=20260417-1")
      .then((registration) => {
        registration.update().catch(() => {
          // Keep silent if update check fails.
        });
      })
      .catch(() => {
        // Keep silent if registration fails.
      });
  });
}
